import React from 'react';

import config from 'util/site_config';
import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';
import useNavigateParams from 'hooks/useNavigateParams';

const sources = () =>
  [...config.sources, ...config.otherSources].sort((a, b) => {
    const labelA = I18n.t(`Explorer.Outputs.SortBy.sort_options.${a}`);
    const labelB = I18n.t(`Explorer.Outputs.SortBy.sort_options.${b}`);
    return labelA.localeCompare(labelB);
  });

const SortBy = () => {
  const params = useQueryParams();
  const navigateParams = useNavigateParams();

  const onSortByChange = (event) => {
    Analytics.trackEvent('research-outputs-sort', { key: event.target.value });
    navigateParams(QueryParams.withSortOrder(params, event.target.value));
  };

  return (
    <div className="Explorer-Outputs-SortBy">
      <label className="label" htmlFor="sortby-select">
        {I18n.t('research_outputs.sort_by')}:
      </label>{' '}
      <select id="sortby-select" onChange={onSortByChange} value={params.sortOrder}>
        <option value="score">{I18n.t('Explorer.Outputs.SortBy.sort_options.score')}</option>
        <option value="score_asc">{I18n.t('Explorer.Outputs.SortBy.sort_options.score_asc')}</option>
        <option value="publication_date">{I18n.t('Explorer.Outputs.SortBy.sort_options.publication_date')}</option>
        <option value="publication_date_asc">
          {I18n.t('Explorer.Outputs.SortBy.sort_options.publication_date_asc')}
        </option>
        <optgroup label={I18n.t('Explorer.Outputs.SortBy.sort_option_groups.source')}>
          {sources().map((source) => (
            <option key={source} value={source}>
              {I18n.t(`Explorer.Outputs.SortBy.sort_options.${source}`)}
            </option>
          ))}
        </optgroup>
        <optgroup label={I18n.t('Explorer.Outputs.SortBy.sort_option_groups.mentions')}>
          {config.mentionTimeframes.map((timeframe) => (
            <option key={timeframe} value={timeframe}>
              {I18n.t(`Explorer.Outputs.SortBy.sort_options.${timeframe}`)}
            </option>
          ))}
        </optgroup>
      </select>
    </div>
  );
};

export default SortBy;
